import { createComponent } from '@carvana/merch-components';

export const DefaultCardContainer = createComponent('div', {
  className:
    'flex flex-col justify-center gap-2xl overflow-hidden rounded-md bg-background-medium p-2xl sm:h-auto md:h-full md:min-h-[218px]'
});

export const DefaultCardContent = createComponent('div', {
  className: 'flex flex-1 flex-col items-start gap-md'
});

export const DefaultCardHeading = createComponent('h3', {
  className: 'text-text-inverse t-heading-md md:t-heading-lg'
});

export const DefaultCardBody = createComponent('p', {
  className: 'text-text-inverse t-body-sm'
});

export const OfferCardContainer = createComponent('div', {
  className:
    'flex h-full flex-col rounded-md border border-border-weak bg-background-default p-2xl md:min-h-[218px]'
});

export const OfferCardContent = createComponent('div', {
  className: 'flex h-full flex-col justify-between gap-xl'
});

export const HeadingSection = createComponent('div', {
  className: 'flex items-start justify-between'
});

export const OfferHeading = createComponent('h3', {
  className: 'text-text-strong t-heading-md md:t-heading-lg'
});
